import ExpTree from './expTree'

function cal(exp) {
  var t = new ExpTree();
  
  if (!t.build(exp)) {
    console.log(exp)
    throw '格式错误!!!'
  }
  
  var dtn = t.dao(t.root);
  var dt = new ExpTree();
  dt.root = dtn;
  
  var x0 = 1, x1 = 2, i = 0
    // ,overStep = false;
  while (Math.abs(x0 - x1) > 10E-9) {
    x0 = x1;
    x1 = x0 - (t.cal(t.root, x0) / dt.cal(dt.root, x0));
    ++i;
    if (i > 10E5) {
      // overStep = true;
      break;
    }
  }
  if (Math.abs(x1 - Math.round(x1)) < 10E-8) {
    x1 = Math.round(x1);
  }
  
  return x1;
}

export default cal